import React, { Component } from 'react';
import Modalviewer from '../Modals/Modalviewer';

require('./about.css');
var Modal = require('boron/WaveModal');
var style = {
    modalStyle: {
        width: '80%',
        height: 'auto',
        padding: '20px',
    }
};
class Offersection extends Component {
    constructor(props) {
        super(props);
        this.state = {
            modalType: ''
        };
    }

    showModal = (typeString) => {
        console.log("Type of Modal to open: " + typeString);
        this.setState({
            modalType: typeString
        });
        this.refs.detailModal.show();
    }

    render() {
        var pics = this.props.pics;
        //var modal = this.showModal();

        const offerCardsData = [
            {
                icon: 'fas fa-eye',
                mainTitle: 'Computer Vision Solutions',
                modalViewerParam: 'visualoffer'
            },
            {
                icon: 'fas fa-home',
                mainTitle: 'IOT Solutions',
                modalViewerParam: 'iotoffer'
            },
            {
                icon: 'fas fa-comments',
                mainTitle: 'Smart Chatbots',
                modalViewerParam: 'chatbotoffer'
            },
            {
                icon: 'fas fa-database',
                mainTitle: 'Data Forecasting and Predictions',
                modalViewerParam: 'predictionoffer'
            },
            {
                icon: 'fas fa-camera-retro',
                mainTitle: 'Face Recognition',
                modalViewerParam: 'faceoffer'
            },
            {
                icon: 'fas fa-microphone',
                mainTitle: 'Speaker Recognition',
                modalViewerParam: 'speakeroffer'
            },
        ];

        return (
            <section id="keyFeatureSection" className='sectionBreak container'>
                <h2 style={{ textAlign: 'center' }}>We use the latest and greatest technologies, such as: </h2>
                <br />
                <div className="tech_used row">
                    <img src={pics.azureLogo} id="tech_used_pic" className="col-md-4" alt="Microsoft Azure Logo" />
                    <img src={pics.tensorFlow} id="tech_used_pic" className="col-md-4" alt="TensorFlow Logo" />
                    <img src={pics.googleCloud} id="tech_used_pic" className="col-md-4" alt="Google Cloud Platform Logo" />
                </div>
                <br />
                <hr />
                <h2 style={{ textAlign: 'center' }}>What We Bring To The Table: </h2>
                <br />
                <div className="our_offers row">
                    {
                        offerCardsData.map((data, key) =>
                            <div
                                className="card offer_card col-md-4" key={key}
                                onClick={() => this.showModal(data.modalViewerParam)}>
                                <i className={data.icon}
                                    style={{ marginRight: 'auto', marginLeft: 'auto', fontSize: '40px' }}></i>
                                <h5 className="text-center offerHeader">{data.mainTitle}</h5>
                            </div>
                        )
                    }
                </div>
                <Modal id="modal_id" ref='detailModal' modalStyle={style.modalStyle}>
                    <Modalviewer modalType={this.state.modalType} pics={pics} />
                </Modal>
            </section>
        );
    }
}

export default Offersection;


// WEBPACK FOOTER //
// ./src/About/Offersection.js